export default __webpack_public_path__ + "static/media/prod7.75f1b205.jpg";